module.exports = __webpack_public_path__ + "static/media/close_icon2.3ae6f862.svg";